import { MenuItem } from 'shared';

export const GoalMenuEditButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <MenuItem
      onClick={(event: MouseEvent) => {
        event.preventDefault();
        onClick();
      }}
    >
      Edit goal details
    </MenuItem>
  );
};
